import React, { useEffect, useRef, useState } from 'react'

//component
import CaretButton from  '@/components/elements/global/buttons/CaretButton'
import SelectButtonList from  '@/components/elements/global/lists/SelectButtonList/SelectButtonList';

//interfaces
import { ISelectButton } from  '@/interfaces/selectButtonList';
import { SortType } from  '@/interfaces/lists';

//utilities
import { reverseMapSortTypeEnum } from  '@/components/elements/lists/ListConstants';
import { getSortTypeFromEnum } from '@/api/lists';



const SortByContentDropdown = ({currentSortType, setSortType, isFeed}:{currentSortType: SortType, setSortType: any, isFeed?: boolean}) => {  
    const dropdownRef = useRef<any>()
    const [showDropdown, setShowDropdown] = useState<boolean>(false);
    const dropDownItems : ISelectButton[]= [
        {content: 'Date Created (Newest)', onClick: () => onClickSortBy(SortType.DateCreatedNewest), isSelected: currentSortType === SortType.DateCreatedNewest},
        {content: 'Date Created (Oldest)',onClick: () => onClickSortBy(SortType.DateCreatedOldest), isSelected: currentSortType === SortType.DateCreatedOldest},
        {content: 'Date Modified (Newest)', onClick: () => onClickSortBy(SortType.DateModifiedNewest), isSelected: currentSortType === SortType.DateModifiedNewest},
        {content: 'Date Modified (Oldest)', onClick: () => onClickSortBy(SortType.DateModifiedOldest), isSelected: currentSortType === SortType.DateModifiedOldest},
        {content: 'Title (A - Z)', onClick: () => onClickSortBy(SortType.TitleAZ), isSelected: currentSortType === SortType.TitleAZ},
        {content: 'Title (Z - A)', onClick: () => onClickSortBy(SortType.TitleZA), isSelected: currentSortType === SortType.TitleZA},
        ...(!isFeed 
            ? [{content: 'Manual', onClick: () => onClickSortBy(SortType.Manual), isSelected: currentSortType === SortType.Manual}]
            : []),
    ]

    useEffect(() => {
        function handleClickOutside(event: Event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) { setShowDropdown(false) }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {document.removeEventListener("mousedown", handleClickOutside)};
    }, []);

    function onClickSortBy(sortByType: any) {
        setSortType(sortByType);
    }
    
    return(
        <div className="sort-by-content-dropdown" ref={dropdownRef}>
            <p>Sort By:</p>
            <CaretButton content={reverseMapSortTypeEnum(currentSortType)} ariaLabel={'Set the sort type for the content list'} onButtonClick={() => setShowDropdown(!showDropdown)}/>
            {showDropdown && <SelectButtonList buttons={dropDownItems} allButtonOnClick={() =>{setShowDropdown(false)}}/>}
            
            {/* JQuery forms parses dom for named inputs to assemble the POST payload, we need to add the missing input */}
            <input id='sortType-hidden' tabIndex={-1} className='hidden' name="SortType" value={getSortTypeFromEnum(currentSortType)}/>
            <label htmlFor='sortType-hidden' className='hidden'>Select Sort Type</label>
        </div>
    )
}

export default SortByContentDropdown